import { useSearchParams, useNavigate } from "react-router-dom";

function PositionsContent() {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const department = searchParams.get("department") || "Department";

  const handlePositionClick = (position) => {
    console.log(`Selected position: ${position} in ${department}`);
    // Example navigation:
    // navigate(`/next-page?department=${department}&position=${position}`);
    navigate("/performance-evaluation/new-evaluation");
  };

  return (
    <div className="min-h-screen font-Outfit bg-gray-50 lg:p-6">
      <div className="lg:max-w-8xl w-full mx-auto">
        <div className="mb-8">
          <h1 className="text-3xl font-Outfit font-semibold text-black mb-2">
            Performance Evaluation
          </h1>
        </div>

        <div className="mb-6 bg-white p-4 min-h-screen">
          <h2 className="text-xl font-semibold text-gray-900 mb-6">
            Select a Position to continue
          </h2>

          <div className="lg:grid-cols-5 grid md:grid-cols-2 grid-cols-1 gap-4 pb-4 scrollbar-hide">
            {[
              "Position 1",
              "Position 2",
              "Position 3",
              "Position 4",
              "Position 5",
            ].map((pos, idx) => (
              <div
                key={idx}
                onClick={() => handlePositionClick(pos)}
                className={`p-6 rounded-2xl cursor-pointer transition-colors min-w-[240px] w-full flex-shrink-0 ${
                  [
                    "bg-green-100 hover:bg-green-200",
                    "bg-pink-100 hover:bg-pink-200",
                    "bg-blue-100 hover:bg-blue-200",
                    "bg-slate-100 hover:bg-slate-200",
                    "bg-yellow-100 hover:bg-yellow-200",
                  ][idx]
                }`}
              >
                <div className="mb-4">
                  <h3 className="text-lg font-semibold text-gray-900 mb-2">
                    Posi tion Titl e
                  </h3>
                  <p className="text-sm font-medium text-green-600">Clone</p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}

export default PositionsContent;
